import styled from 'styled-components';
import { EXCHANGE_COLLATERAL_PAGE_BG } from '../../config/media';

const Wrapper = styled.div`
	position: relative;
	height: 100%;
	.flex-between {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.flex-center {
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.collateral-description {
		font-size: 12px;
	}
	.text-center {
		text-align: center;
	}
	.main-panel {
		width: 100%;
		min-height: 100%;
		background-color: #000000;
		background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 1), rgba(0, 0, 0, 1), rgba(0, 0, 0, 1)), url(${EXCHANGE_COLLATERAL_PAGE_BG});
		background-repeat: no-repeat;
		background-size: calc(100vw - 310px);
		font-size: 12px;
		padding: 40px 75px;
		position: relative;
		box-sizing: border-box;
		color: #fff;
		.ant-btn {
			padding-left: 10px;
			padding-right: 10px;
			margin: 0px 3px;
			min-width: 7rem;
			max-width: 7rem;
			// position: absolute;
			// top: 40px;
			// right: 110px;
			// font-size: 22px;
			// height: auto;
		}
		h2 {
			font-size: 35px;
			font-weight: bold;
			margin-bottom: 14px;
			color: #fff;
		}
		p {
			.advatages {
				text-indent: 12px;
				display: block;
			}
			.click {
				cursor: pointer;
				color: #5985ff;
				text-decoration: underline;
			}
		}
		.remove-btn {
			color: #ffffff;
		}
		.user-xht {
			height: 3.5rem;
			margin-left: 5px;
			width: 3.5rem;
		}
		.title {
			font-weight: bold;
			color: #ffffff;
		}
		.configure-link {
			cursor: pointer;
			color: #5985ff;
			text-decoration: underline;
		}
		.text-end {
			text-align: right;
		}
		.public {
			color: #36E900;
		}
	}
	.sponsor {
		background: #FFFBE6 0% 0% no-repeat padding-box;
		border: 1px solid #DCE18E;
		display: flex;
		margin: 20px 0px;
		padding: 8px 10px;
		color: #000000;
		.hand-icon {
			width: 3rem;
			margin-right: 0.5rem;
		}
		h4 {
			font-weight: bold;
		}
		.small-text {
			font-size: 10px;
		}
		.link {
			color:#3A4FFF;
			cursor: pointer;
		}
	}
	.collateral {
		padding: 32px 0px;
		.anticon {
			padding-right: 6px;
		}
	}
	.msg-container {
		padding: 0 71px;
	}
	@media (max-width: 1200px) {
		z-index: 0;
		.collateral,
		.main-panel {
			padding: 24px;
			padding-left: 28px;
			background-size: calc(100vw - 0px);
			h2 {
				font-size: 24px;
			}
		}
		.sponsor {
			margin: 15px;
			margin-left: 28px;
		}
		.main-panel {
			font-size: 12px;
			background-repeat: repeat;
			.collateral-amount-container {
				.flex-between {
					flex-direction: column !important;
					align-items: flex-start !important;
				}
				.flex-center {
					justify-content: flex-start !important;
				}
			}
		}
	}
`;

export default Wrapper;

export const CollateralModalWrapper = styled.div`
	color: #fff;
  	.btn-wrapper {
		display: flex;
		justify-content: space-between;
		margin: 40px 0 15px 0;
		.ant-btn {
			width: 200px;
			height: 40px;
			background-color: #3A4FFF;
		}
		.ant-btn-primary[disabled] {
			background-color: #42454D;
			opacity: 0.5;
		}
  	}
  	.step-1-container {
		.img-wrapper{
			display: flex;
			justify-content: center;
			align-items: center;
		}
		.live-public-img {
			width: 150px;
		}
		.header-txt {
			font-size: 19px;
			font-weight: bold;
			text-align: center;
		}
		.info-txt {
			text-align: center;
		}
		.Footer-txt {
			margin-top: 20px;
			text-align: center;
		}
  	}
	.step-2-container, .step-3-container {
		margin-top: 10px;
		.header-txt {
			font-size: 19px;
			font-weight: bold;
			margin-bottom: 10px;
		}
		.inner-content {
			margin-top: 30px;
			.ant-input {
				border-radius: 0;
				border-color: #A8A8B1;
				background-color: #212121;
   				color: #fff;
				margin-top: 8px;
			}
			.ant-input:focus ,.ant-input:hover {
    			border-color: #A8A8B1 !important;
			}
			.Project_field {
				font-weight: bold;
				color: #fff;
			}
		}
		.info-align {
			margin-top: 20px;
			padding-right: 15px;
		}
	}
`
